/* YovcityBargain Theme JS */

(function() {
  'use strict';

  // ============================================
  // Announcement Bar Auto-Rotate
  // ============================================
  function initAnnouncementBar() {
    var bars = document.querySelectorAll('.announcement-bar');
    bars.forEach(function(bar) {
      var items = bar.querySelectorAll('.announcement-bar__item');
      var autoRotate = bar.dataset.autoRotate === 'true';
      var speed = parseInt(bar.dataset.speed || '5', 10) * 1000;

      if (items.length <= 1 || !autoRotate) return;

      var currentIndex = 0;
      items[0].classList.add('is-active');

      setInterval(function() {
        items[currentIndex].classList.remove('is-active');
        currentIndex = (currentIndex + 1) % items.length;
        items[currentIndex].classList.add('is-active');
      }, speed);
    });
  }

  // ============================================
  // Mobile Navigation
  // ============================================
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    var closeButtons = document.querySelectorAll('[data-mobile-nav-close]');

    if (!toggle || !mobileNav) return;

    toggle.addEventListener('click', function() {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // ============================================
  // Product Gallery (Product Page)
  // ============================================
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var mainImage = document.getElementById('product-main-image');

    if (!thumbs.length || !mainImage) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var newSrc = this.dataset.image;
        if (newSrc) {
          mainImage.src = newSrc;
        }
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });
  }

  // ============================================
  // Quantity Selector
  // ============================================
  function initQuantitySelectors() {
    document.querySelectorAll('[data-quantity-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentElement.querySelector('.quantity-input');
        var val = parseInt(input.value, 10) - 1;
        if (val >= 1) input.value = val;
      });
    });

    document.querySelectorAll('[data-quantity-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentElement.querySelector('.quantity-input');
        input.value = parseInt(input.value, 10) + 1;
      });
    });
  }

  // ============================================
  // Cart Quantity (AJAX)
  // ============================================
  function initCartQuantity() {
    document.querySelectorAll('[data-cart-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentElement.querySelector('.quantity-input');
        var val = parseInt(input.value, 10) - 1;
        if (val >= 0) {
          input.value = val;
          updateCart(input.dataset.line, val);
        }
      });
    });

    document.querySelectorAll('[data-cart-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentElement.querySelector('.quantity-input');
        var val = parseInt(input.value, 10) + 1;
        input.value = val;
        updateCart(input.dataset.line, val);
      });
    });

    document.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.closest('.cart-item').querySelector('.quantity-input');
        if (input) {
          updateCart(input.dataset.line, 0);
        }
      });
    });
  }

  function updateCart(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(response) { return response.json(); })
    .then(function() { window.location.reload(); })
    .catch(function() { window.location.reload(); });
  }

  // ============================================
  // Collection Sort
  // ============================================
  function initCollectionSort() {
    var sortSelect = document.querySelector('[data-sort]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });

    // Set current sort value from URL
    var currentSort = new URLSearchParams(window.location.search).get('sort_by');
    if (currentSort) {
      sortSelect.value = currentSort;
    }
  }

  // ============================================
  // Cart Count Update (AJAX Add to Cart)
  // ============================================
  function initCartForms() {
    var cartForms = document.querySelectorAll('.product-card__form');
    cartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(form);
        var data = {};
        formData.forEach(function(value, key) { data[key] = value; });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          // Update cart count
          var countEl = document.querySelector('[data-cart-count]');
          if (countEl) {
            countEl.textContent = cart.item_count;
          }
          // Show feedback
          var btn = form.querySelector('.product-card__add-btn');
          if (btn) {
            var originalText = btn.textContent;
            btn.textContent = 'Added!';
            btn.style.background = '#22c55e';
            setTimeout(function() {
              btn.textContent = originalText;
              btn.style.background = '';
            }, 1500);
          }
        })
        .catch(function(err) {
          console.error('Cart add error:', err);
        });
      });
    });
  }

  // ============================================
  // Header Scroll Effect
  // ============================================
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        header.style.boxShadow = '0 2px 20px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ============================================
  // Init All
  // ============================================
  document.addEventListener('DOMContentLoaded', function() {
    initAnnouncementBar();
    initMobileNav();
    initProductGallery();
    initQuantitySelectors();
    initCartQuantity();
    initCollectionSort();
    initCartForms();
    initHeaderScroll();
  });

})();
